export const colors = {
  ALMOST_BLACK: '#002229',
  RICH_BLACK: '#00333A',
  WHITE: '#FFFFFF',
  MOONSTONE: '#31afb4',
  CARMINE_RED: '#B43631',
  // MUI_PRIMARY: '#1976d2',
  // DRAWER_GROUP_LABEL: '#d4d4d4',
  // AVATAR: '#90caf9'
}
